import { ChartDashboardItem } from "../../../components";
import { useAsync } from "../../../hooks";
import { DashboardService } from "../../../services";
import { DashboardRequest } from "../../../models";
import { WeeklyBookingResponse } from "../../../models/dashboard/linegraph/WeeklyBookingResponse";
import { useSelector } from "react-redux";
import { getUserInfo } from "../../../app";
import { ChartSeriesItem } from "@progress/kendo-react-all";

export function LocationLineChart() {

  const dashboardService = new DashboardService();
  const userId = useSelector(getUserInfo())?.id;
  const locationIds = useSelector(getUserInfo())?.locationIds ?? [];

  const request: DashboardRequest = {
    options: {
      userId: userId,
      currentDate: new Date().toISOString().split("T")[0],
      numberOfWeeks: 5,
      locationIds: locationIds,
    },
    name: "weeklyBooking",
  };
  const { value, loading, error } = useAsync(() => dashboardService.postAsync<WeeklyBookingResponse>(request), [])

  return (
    <ChartDashboardItem
      categories={value?.startDates ?? []}
      series={value?.bookingCounts ?? []}
      type="line"
    >
      {value?.items && value?.items.length > 0 ? (
        value.items.map((item, index) => (
          <ChartSeriesItem
            key={index}
            name={item.locationName}
            data={item.bookingCounts}
            type="line"
          />
        ))
      ) : (
        <ChartSeriesItem
          type="line"
          data ={value?.bookingCounts}
        />
      )}
    </ChartDashboardItem>
  );
}

export default LocationLineChart;
